import React, { useState, useEffect } from "react";
import styles from "./TranslationRow.module.css";

import { useDispatch, useSelector } from "react-redux";
import { languageActions } from "@_actions/language.actions";

import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import FlagIcon from "@mui/icons-material/Flag";
import Tooltip from "@mui/material/Tooltip";
import CheckIcon from "@mui/icons-material/Check";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import LanguageList from "@_configs/LanguageList.config";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
function TranslationRow(props) {
  let translation = props.translation;

  const dispatch = useDispatch();
  const anchorRef = React.useRef(null);
  const languageReducer = useSelector((state) => state.languageReducer);

  const [openEditPopup, setOpenEditPopup] = useState(false);
  const history = useHistory();

  const handleOpenEditPopup = (e) => {
    e.stopPropagation();
    setOpenEditPopup((prev) => !prev);
  };

  const handleCloseEditPopup = (e) => {
    e.stopPropagation();
    setOpenEditPopup(false);
  };

  const handleDeleteTranslation = (e, translation) => {
    e.stopPropagation();
    let data = {
      language: translation,
    };
    dispatch(languageActions.deleteTranslation(data));
    history.push("/admin/settlement_portal/translations");
  };

  const handleSelectTranslation = (data) => {
    dispatch(languageActions.selectTranslation(data));
    history.push(
      "/admin/settlement_portal/translations/" +
        LanguageList.find(
          (lang) => lang.code === translation.language,
        )?.language.toLowerCase(),
    );
  };

  useEffect(() => {
    if (languageReducer.status.TRANSLATION_DELETE === "success") {
      history.push("/admin/settlement_portal/translations");
      dispatch(languageActions.selectTranslation(null));
      dispatch(languageActions.getTranslations());
      dispatch(languageActions.clearStatusMessage("TRANSLATION_DELETE"));
    }
  }, [dispatch, history, languageReducer.status.TRANSLATION_DELETE]);

  return (
    <div>
      <div
        key={translation.language}
        onClick={() => handleSelectTranslation(translation)}
        className={
          (languageReducer.selected_translation &&
            languageReducer.selected_translation.language) ===
          translation.language
            ? styles.translation_row_root_selected
            : styles.translation_row_root
        }
      >
        <div className={styles.short_language}>
          <p>
            <b> {translation.language.toUpperCase()}</b>
          </p>
        </div>
        <div className={styles.long_language}>
          <p>
            {LanguageList.find(
              (lang) => lang.code === translation.language,
            )?.language.toUpperCase() || "UNKNOWN"}
          </p>
        </div>
        <div className={styles.default_translation}>
          {languageReducer.translations.default_translation_id ===
            translation.id && (
            <Tooltip title={<p>default</p>}>
              <FlagIcon fontSize="small" />
            </Tooltip>
          )}
        </div>
        <div className={styles.active_translation}>
          {translation.is_active === 1 && (
            <Tooltip title={<p>active</p>}>
              <CheckIcon fontSize="small" />
            </Tooltip>
          )}
        </div>

        <div className={styles.default_translation}>
          <MoreHorizIcon
            fontSize="small"
            className={styles.btn_add_language}
            onClick={(e) => handleOpenEditPopup(e)}
            ref={anchorRef}
            aria-controls={openEditPopup ? "translation-menu" : undefined}
            aria-haspopup="true"
          />
          <Menu
            id="translation-menu"
            anchorEl={anchorRef.current}
            open={openEditPopup}
            onClose={handleCloseEditPopup}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem
              onClick={(e) => handleDeleteTranslation(e, translation.language)}
            >
              Delete
            </MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
}

export default TranslationRow;
